export default {
  remote: 'simplify_hub_namespace_generator_mfe',
  name: 'namespace-generator',
  source: 'https://github.com/telus/cloud-coe-simplify-backstage-plugins',
  urlMapping: {
    localhost: 'https://assets.wcpreview.telus.com/642608889/ccoe-namespace-generator/v1/mf2/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/642608889/ccoe-namespace-generator/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/642608889/ccoe-namespace-generator/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/642608889/ccoe-namespace-generator/v1/mf2/mf-manifest.json',
  },
};
